import src from "IMAGE";
export default { src, width: 986, height: 768, blurWidth: 0, blurHeight: 0};
